import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { AbstractRefreshTokenAdaptor } from '../../../common/auth/auth-token/abstract-refresh-token.adaptor';
import { AuthRefreshTokenPayload } from '../../../common/auth/auth-token/auth-refresh-token.model';
import { AuthService } from '../../../common/auth/auth.service';

interface RefreshTokenResponse {
  jwt: string;
  refresh_token: string;
  jwt_expire_at: string;
  refresh_token_expire_at: string;
}

@Injectable()
export class RefreshTokenAdaptor extends AbstractRefreshTokenAdaptor {
  private http = inject(HttpClient);
  private auth = inject(AuthService);

  override onRefreshToken(payload: AuthRefreshTokenPayload): Observable<AuthRefreshTokenPayload> {
    return this.http
      .post<RefreshTokenResponse>('/accounts/refresh_tokens', null, {
        params: { refresh_token: payload.refreshToken },
      })
      .pipe(
        map((res) => {
          const { jwt: accessToken, refresh_token: refreshToken, jwt_expire_at, refresh_token_expire_at } = res;
          return {
            accessToken,
            refreshToken,
            accessTokenExpiry: new Date(jwt_expire_at),
            refreshTokenExpiry: new Date(refresh_token_expire_at),
          };
        }),
      );
  }

  override onRefreshTokenFail() {
    this.auth.logout();
  }
}
